import { render, staticRenderFns } from "./LocationInfos.vue?vue&type=template&id=1b1a74e7"
import script from "./LocationInfos.vue?vue&type=script&lang=js"
export * from "./LocationInfos.vue?vue&type=script&lang=js"
import style0 from "./LocationInfos.vue?vue&type=style&index=0&id=1b1a74e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports